// import { FaShoppingCart } from "react-icons/fa";
// import cornerIcon from "../../Assets/cornerIcon.png";
// import { useState, useEffect } from "react";
// import "./OurPackagesPageCss/OurPackageMainSection.css";
// import { IoSearchOutline } from "react-icons/io5";
// import AnimatedText from "../../AnimatedText";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// import PackageDetailsModal from "./PackageDetailsModel";

// import png1 from "../../Assets/Medical doctor_ 1.png";

// import CompareModal from "./CompareModal";
// import FloatingCompareBox from "./FloatingCompareBox";

// import rbdLogo from "../../Assets/rbdLogo.png";

// import { useCart } from "../../Contexts/Cart.contexts";
// import { getPackageList, getTestList } from "../../api/api";
// import CustomPagination from "../../common/CustomPagination";
// import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
// import { GiHypodermicTest } from "react-icons/gi";
// import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
// import { getAgeRangeString, isAgeInRange } from "../../utils/helper";
// import ViewPackageDetails from "./OurPackagesPageCss/ViewPackageDetails";
// import TestDropdown from "./TestDropdown";
// import { TruncateText } from "../../common/TruncateText";
// import CustomLoader from "../../common/loader/CustomLoader";
// import toast from "react-hot-toast";
// import { useNavigate } from "react-router-dom";
// import { FaFilter } from "react-icons/fa6";

// function getDiscountedPrice(originalPrice, offerPercent) {
//   if (!originalPrice || originalPrice <= 0) return 0;
//   if (!offerPercent || offerPercent <= 0) return originalPrice;

//   const discount = (offerPercent / 100) * originalPrice;
//   const finalPrice = originalPrice - discount;

//   return Math.round(finalPrice);
// }

// const OurPackageMainSection = () => {
//   const { addToCart, cartItems, setCartItems } = useCart();
//   const [packageList, setPackageList] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [searchResults, setSearchResults] = useState(null);
//   const [testList, setTestList] = useState([]);
//   const [selectedTests, setSelectedTests] = useState([]);
//   const navigator = useNavigate();

//   useEffect(() => {
//     fetchPackageListData();
//     fetchTestListData();
//   }, []);

//   const fetchTestListData = async () => {
//     const payload = {
//       RBAuthKey: "RBDWAh!Q1s74e",
//       Center_ID: "",
//       search_key: "",
//     };
//     try {
//       setLoading(true);
//       const res = await getTestList(payload);
//       setTestList(res?.data?.data);
//     } catch (error) {
//       console.error("Error fetching test list:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchPackageListData = async () => {
//     const payload = {
//       search_key: "",
//     };
//     try {
//       setLoading(true);
//       const res = await getPackageList(payload);
//       const filterShowInWeb = res?.data?.data?.filter(
//         (item) => item.ShowInWeb === "Y"
//       );
//       setPackageList(filterShowInWeb || []);
//     } catch (error) {
//       console.error("Error fetching Package list:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSearch = (query) => {
//     const trimmedQuery = query.trim();
//     setSearchQuery(query);

//     if (!trimmedQuery) {
//       setSearchResults(packageList);
//       setCurrentPage(1);
//       return;
//     }

//     const lowerQuery = trimmedQuery.toLowerCase();
//     const filteredCards = packageList.filter((card) =>
//       (card?.service_name || "").toLowerCase().includes(lowerQuery)
//     );

//     setSearchResults(filteredCards);
//     setCurrentPage(1);
//   };

//   const handleClearSearch = () => {
//     setSearchQuery("");
//     setSearchResults(null);
//   };

//   const discount = 11;

//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
//   useEffect(() => {
//     const checkMobile = () => setIsMobile(window.innerWidth <= 768);
//     checkMobile();
//     window.addEventListener("resize", checkMobile);
//     return () => window.removeEventListener("resize", checkMobile);
//   }, []);

//   useEffect(() => {
//     const handleResize = () => {
//       const width = window.innerWidth;
//       if (width <= 768 && width > 480) {
//         setRenderMode("dropdown"); // mid-sized phones/tablets
//       } else if (width <= 480) {
//         setRenderMode("dropdown"); // tiny screens
//       } else {
//         setRenderMode("buttons"); // desktop
//       }
//     };

//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const sliderSettings = {
//     dots: false,
//     arrows: false,
//     infinite: false,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 2000,
//     cssEase: "ease-in-out",
//     responsive: [
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           arrows: true,
//           infinite: false,
//         },
//       },
//     ],
//   };

//   // const handleAddToCart = (packageData) => {
//   //   addToCart({
//   //     id: Date.now().toString() + Math.random().toString(36).substr(2, 5),
//   //     product: packageData.title,
//   //     price: packageData.price,
//   //     quantity: 1,
//   //   });
//   // };

//   const handleAddToCart = (packageData) => {
//     // console.log("Adding to cart:", packageData);
//     if (packageData?.service_id === cartItems?.service_id) {
//       toast.error("Item already in cart");
//     }
//     addToCart({
//       id: packageData.service_id,
//       product: packageData?.service_name,
//       price: packageData.price,
//       quantity: 1,
//     });
//   };

//   const renderCard = (card, index) => {
//     const isAdded =
//       cartItems && cartItems.some((item) => item.id === card.service_id);
//     const handleToggleCart = () => {
//       if (isAdded) {
//         // remove from cart
//         setCartItems((prev) =>
//           prev.filter((item) => item.id !== card.service_id)
//         );
//       } else {
//         // add to cart
//         // setCartItems((prev) => [...prev, { id: card.service_id, ...card }]);
//         handleAddToCart(card);
//       }
//     };
//     return (
//       <div key={index} className="carouselCardWrapper">
//         <div className="packageCard mainPackageCard wide-card">
//           <div className="cornerImage">
//             <div className="upperCardText">
//               <img className="logoimg" src={rbdLogo} alt="RBD logo" />
//             </div>
//             <img
//               src={cornerIcon}
//               alt="corner icon"
//               style={{ width: "3.5rem" }}
//             />
//           </div>

//           <div className="cardTitlePack mainpackageTitlePack">
//             <h2
//               style={{ margin: "5px 0px", fontSize: "18px", color: "#0fb7a4" }}
//             // title={card?.service_name}
//             >
//               {/* {card?.service_name.length > 25
//               ? `${card?.service_name.slice(0, 25)}...`
//               : card?.service_name} */}
//               <TruncateText text={card?.service_name} maxLength={25} />
//             </h2>
//           </div>

//           <span className="testAndComp" style={{ color: "darkcyan" }}>
//             <p>
//               Covers {card?.list.length} Tests with {card?.NoOfParams}{" "}
//               components{" "}
//             </p>

//             {card.parameters && card.parameters.length > 0 && (
//               <div className="cardParameters">
//                 <h4
//                   style={{
//                     fontSize: "15px",
//                     fontWeight: "700",
//                     marginTop: "10px",
//                     margin: "0",
//                   }}
//                 >
//                   Parameters
//                 </h4>
//                 <ul style={{ paddingLeft: "20px", margin: "5px 0" }}>
//                   {card?.list.map((param, idx) => (
//                     <li
//                       key={idx}
//                       style={{ textDecoration: "none", fontSize: "13px" }}
//                     >
//                       {param}
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             )}
//           </span>

//           {/* <div className="cardsMiddleSec">
//                     <h4 style={{ fontSize: "12px", fontWeight: "500" }}>Same Day Report Delivery</h4>
//                 </div> */}

//           <div className="priceSection">
//             <h2 style={{ fontSize: "14px", color: "red" }}>
//               &#8377; <del>{card.PackageRate}</del>
//             </h2>
//             <h2 style={{ fontSize: "14px", color: "green" }}>
//               {card?.priceOff}% Off
//             </h2>
//             <h2 style={{ margin: "0", color: "grey", fontSize: "14px" }}>
//               &#8377; {card.price}
//             </h2>
//           </div>

//           <div className="compareSectionOurPackage">
//             <div className="cardLowerRigntSec">
//               <input
//                 type="checkbox"
//                 id={`compare-${index}`}
//                 checked={compareList.some(
//                   (c) => c.service_name === card.service_name
//                 )}
//                 onChange={() => handleToggleCompare(card)}
//               />
//               <label htmlFor={`compare-${index}`}>Compare</label>
//             </div>
//           </div>

//           <div className="cardLowerSec">
//             <button
//               className="rbdButton"
//               title="Click to View Details"
//               onClick={() => handleViewDetails(card)}
//             >
//               <span className="btn-text">View Details</span>
//             </button>
//             <button
//               className={`rbdButton addCartBtn ${isAdded ? "added" : ""}`}
//               title={isAdded ? "Added" : "Item Added"}
//               onClick={handleToggleCart}
//             >
//               <span className="btn-text">
//                 {isAdded ? "Added Item" : "Add to Cart"}
//               </span>
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const [activeTab, setActiveTab] = useState("All");
//   const [filters, setFilters] = useState({
//     fasting: "",
//     gender: "",
//     ageRange: "",
//   });
//   const [currentPage, setCurrentPage] = useState(1);
//   const cardsPerPage = 12;
//   const [sortOrder, setSortOrder] = useState("none"); // 'none', 'asc', 'desc'

//   const categories = [
//     "All",
//     "General Wellness",
//     "Lifestyle",
//     "Male Care",
//     "Female Care",
//     "Cardiology",
//     "Dialysis",
//     "Gynaecology",
//     "Diabetes",
//   ];

//   const navigate = useNavigate();

//   const getCardsForCategory = (category) => {
//     if (category === "All") {
//       return categories
//         .filter((cat) => cat !== "All")
//         .flatMap((cat) => getCardsForCategory(cat));
//     }

//     // switch (category) {
//     //   case "General Wellness":
//     //     return [
//     //       {
//     //         title: "Serology Profile",
//     //         TestsAndComp: ["4 Tests", "7 Components"],
//     //         price: 1600,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //         parameters: ["Laboratory Tests", "Radiology Tests"],
//     //         testDetails: [
//     //           {
//     //             name: "HBsAg",
//     //             department: "SEROLOGY",
//     //             reportTime: 0,
//     //             preparation: "No special preparation",
//     //             serviceKey: "HBsAg (Hepatitis B surface Antigen) ECLIA",
//     //           },
//     //           {
//     //             name: "HCV",
//     //             department: "SEROLOGY",
//     //             reportTime: 1,
//     //             preparation: "No fasting required",
//     //             serviceKey: "HCV Antibody Test",
//     //           },
//     //           {
//     //             name: "HIV I & II",
//     //             department: "SEROLOGY",
//     //             reportTime: 1,
//     //             preparation: "No special preparation",
//     //             serviceKey: "HIV I/II Rapid Test",
//     //           },
//     //           {
//     //             name: "VDRL/RPR - Rapid Test",
//     //             department: "SEROLOGY",
//     //             reportTime: 1,
//     //             preparation: "No special preparation",
//     //             serviceKey: "VDRL RPR Test",
//     //           },
//     //         ],
//     //       },
//     //       {
//     //         title: "Master Health Check up",
//     //         TestsAndComp: ["15 Tests", "88 Components"],
//     //         price: 3500,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //         parameters: ["Laboratory Tests", "Radiology Tests"],
//     //         testDetails: [
//     //           {
//     //             name: "CBC",
//     //             department: "HEMATOLOGY",
//     //             reportTime: 1,
//     //             preparation: "No special preparation",
//     //             serviceKey: "Complete Blood Count",
//     //           },
//     //           {
//     //             name: "Lipid Profile",
//     //             department: "BIOCHEMISTRY",
//     //             reportTime: 1,
//     //             preparation: "12-hour fasting recommended",
//     //             serviceKey: "Lipid Panel",
//     //           },
//     //           {
//     //             name: "Liver Function Test",
//     //             department: "BIOCHEMISTRY",
//     //             reportTime: 1,
//     //             preparation: "Fasting preferred",
//     //             serviceKey: "LFT",
//     //           },
//     //         ],
//     //       },
//     //       {
//     //         title: "Executive Health Check Up",
//     //         TestsAndComp: ["17 Tests", "95 Components"],
//     //         price: 5000,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //         parameters: ["Laboratory Tests", "Radiology Tests"],
//     //         testDetails: [],
//     //       },
//     //       {
//     //         title: "Master Health Check up, Blood",
//     //         TestsAndComp: ["12 Tests", "75 Components"],
//     //         price: 1900,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //         parameters: ["Laboratory Tests", "Radiology Tests"],
//     //         testDetails: [],
//     //       },

//     //       {
//     //         title: "Full Body Platinum Package (Blood)",
//     //         TestsAndComp: ["15 Tests", "87 Components"],
//     //         price: 4000,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //         parameters: ["Laboratory Tests", "Radiology Tests"],
//     //         testDetails: [],
//     //       },
//     //       {
//     //         title: "Full Body Platinum Package (Male)",
//     //         TestsAndComp: ["21 Tests", "93 Components"],
//     //         price: 6900,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //         parameters: ["Laboratory Tests", "Radiology Tests"],
//     //         testDetails: [],
//     //       },
//     //     ];
//     //   case "Lifestyle":
//     //     return [
//     //       {
//     //         title: "KFT",
//     //         TestsAndComp: ["7 Tests", "7 Components"],
//     //         price: 1300,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //         parameters: ["Laboratory Tests", "Radiology Tests"],
//     //       },
//     //       {
//     //         title: "Iron Profile",
//     //         TestsAndComp: ["2 Tests", "5 Components"],
//     //         price: 1400,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         parameters: ["Laboratory Tests", "Radiology Tests"],
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "Coagulation Profile",
//     //         TestsAndComp: ["4 Tests", "39 Components"],
//     //         price: 1400,
//     //         fasting: "Yes",
//     //         parameters: ["Laboratory Tests", "Radiology Tests"],
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "RPI",
//     //         TestsAndComp: ["4 Tests", "11 Components"],
//     //         price: 700,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         parameters: ["Laboratory Tests", "Radiology Tests"],
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "Elec/Renal",
//     //         TestsAndComp: ["6 Tests", "9 Components"],
//     //         price: 1700,
//     //         fasting: "Yes",
//     //         parameters: ["Laboratory Tests", "Radiology Tests"],
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "RPII",
//     //         TestsAndComp: ["5 Tests", "38 Components"],
//     //         price: 1100,
//     //         fasting: "Yes",
//     //         parameters: ["Laboratory Tests", "Radiology Tests"],
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //       },
//     //     ];
//     //   case "Male Care":
//     //     return [
//     //       {
//     //         title: "RBD Healthy Life, Blood (Male)",
//     //         TestsAndComp: ["15 Tests", "98 Components"],
//     //         price: 4000,
//     //         fasting: "Yes",
//     //         gender: "Male",
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "RBD Healthy Life (Male)",
//     //         TestsAndComp: ["21 Tests", "104 Components"],
//     //         price: 6900,
//     //         fasting: "Yes",
//     //         gender: "Male",
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "Health Check Up (Male)",
//     //         TestsAndComp: ["19 Tests", "90 Components"],
//     //         price: 6000,
//     //         fasting: "Yes",
//     //         gender: "Male",
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "Prostate Screening Test",
//     //         TestsAndComp: ["3 Tests", "3 Components"],
//     //         price: 2200,
//     //         fasting: "Yes",
//     //         gender: "Male",
//     //         ageRange: "18-35",
//     //       },
//     //     ];
//     //   case "Female Care":
//     //     return [
//     //       {
//     //         title: "RBD Healthy Life, Blood (Female)",
//     //         TestsAndComp: ["15 Tests", "98 Components"],
//     //         price: 4000,
//     //         fasting: "Yes",
//     //         gender: "Female",
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "RBD Healthy Life (Female)",
//     //         TestsAndComp: ["21 Tests", "104 Components"],
//     //         price: 6900,
//     //         fasting: "Yes",
//     //         gender: "Female",
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "Health Check Up (Female)",
//     //         TestsAndComp: ["19 Tests", "90 Components"],
//     //         price: 6000,
//     //         fasting: "Yes",
//     //         gender: "Female",
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "PCOS/PCOD Profile",
//     //         TestsAndComp: ["6 Tests", "6 Components"],
//     //         price: 2200,
//     //         fasting: "Yes",
//     //         gender: "Female",
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "Pregnancy Profile",
//     //         TestsAndComp: ["11 Tests", "64 Components"],
//     //         price: 3700,
//     //         fasting: "Yes",
//     //         gender: "Female",
//     //         ageRange: "18-35",
//     //       },
//     //     ];
//     //   case "Cardiology":
//     //     return [
//     //       {
//     //         title: "Cardiac Enzyme Profile",
//     //         TestsAndComp: ["0 Tests", "4 Components"],
//     //         price: 1250,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "Pre Cath Profile 1",
//     //         TestsAndComp: ["8 Tests", "38 Components"],
//     //         price: 2500,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "Cardiac Health Check Up >45 Yrs",
//     //         TestsAndComp: ["18 Tests", "79 Components"],
//     //         price: 5500,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "Pre Cardiac-angio Checkup",
//     //         TestsAndComp: ["17 Tests", "97 Components"],
//     //         price: 5000,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "Cardiac Injury Profile",
//     //         TestsAndComp: ["7 Tests", "40 Components"],
//     //         price: 2200,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "Cardiac Health Check Up (Blood)",
//     //         TestsAndComp: ["15 Tests", "86 Components"],
//     //         price: 4000,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "Cardiac Health Check Up <45 Yrs",
//     //         TestsAndComp: ["17 Tests", "77 Components"],
//     //         price: 5200,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //       },
//     //     ];
//     //   case "Dialysis":
//     //     return [
//     //       {
//     //         title: "Dialysis Special Offer (Multiuse)",
//     //         TestsAndComp: ["0 Tests", "2 Components"],
//     //         price: 1800,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "Dialysis Special Offer (Singleuse)",
//     //         TestsAndComp: ["0 Tests", "2 Components"],
//     //         price: 2200,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //       },
//     //     ];
//     //   case "Gynaecology":
//     //     return [
//     //       {
//     //         title: "FSH, LH, PRL",
//     //         TestsAndComp: ["3 Tests", "3 Components"],
//     //         price: 1600,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "LH & FSH",
//     //         TestsAndComp: ["2 Tests", "2 Components"],
//     //         price: 1000,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "Antenatal Profile",
//     //         TestsAndComp: ["8 Tests", "61 Components"],
//     //         price: 1900,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "Pre-Marriage Profile",
//     //         TestsAndComp: ["5 Tests", "15 Components"],
//     //         price: 1500,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "BOH (Bad Obstetric History) Panel",
//     //         TestsAndComp: ["8 Tests", "32 Components"],
//     //         price: 9000,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //       },
//     //       {
//     //         title: "Infertility Profile",
//     //         TestsAndComp: ["13 Tests", "31 Components"],
//     //         price: 5800,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //       },
//     //     ];
//     //   case "Diabetes":
//     //     return [
//     //       {
//     //         title: "Diabetic Profile",
//     //         TestsAndComp: ["8 Tests", "70 Components"],
//     //         price: 2100,
//     //         fasting: "Yes",
//     //         gender: "Any",
//     //         ageRange: "18-35",
//     //       },
//     //     ];
//     //   case "Offers":
//     //     return Array(16).fill({
//     //       title: "Summer Special Package",
//     //       TestsAndComp: ["15 Tests", "50 Components"],
//     //       price: 2500,
//     //       fasting: "Yes",
//     //       gender: "Any",
//     //       ageRange: "51+",
//     //     });
//     //   default:
//     //     return [];
//     // }
//   };

//   const applyFilters = (cards) => {
//     return cards.filter((card) => {
//       const { fasting, gender, ageRange } = filters;
//       return (
//         (fasting ? card.Fasting === fasting : true) &&
//         (gender ? card.Gender === gender : true) &&
//         (ageRange ? card.AgeRange === ageRange : true)
//       );
//     });
//   };

//   const handleResetFilters = () => {
//     setFilters({ fasting: "", gender: "", ageRange: "" });
//     setCurrentPage(1);
//   };

//   const handleRadioResetFilters = () => {
//     setSortOrder("none");
//     setSearchResults(null);
//   };

//   const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

//   // Filtering logic for fasting, gender, and ageRange
//   const filterCards = (cards) => {
//     return cards.filter((card) => {
//       const fastingMatch =
//         filters.fasting === "All" ||
//         filters.fasting === "" ||
//         card?.Fasting === filters.fasting;
//       const genderMatch =
//         filters.gender === "All" ||
//         filters.gender === "" ||
//         card?.Gender === filters.gender;
//       const ageMatch = isAgeInRange(
//         card?.minAge,
//         card?.maxAge,
//         filters.ageRange
//       );
//       //   console.log("Card Age Value:", cardAgeValue);
//       //   const ageMatch =
//       //     filters.ageRange === "All" ||
//       //     filters.ageRange === "" ||
//       //     cardAgeValue === filters.ageRange;
//       return fastingMatch && genderMatch && ageMatch;
//     });
//   };

//   // Sorting function
//   function sortCards(cards) {
//     if (sortOrder === "asc") {
//       return [...cards].sort((a, b) => (a.price || 0) - (b.price || 0));
//     } else if (sortOrder === "desc") {
//       return [...cards].sort((a, b) => (b.price || 0) - (a.price || 0));
//     }
//     return cards;
//   }

//   const filteredCards = filterCards(packageList);
//   const sortedCards = sortCards(filteredCards);
//   const indexOfLastCard = currentPage * cardsPerPage;
//   const indexOfFirstCard = indexOfLastCard - cardsPerPage;
//   const currentCards = sortedCards.slice(indexOfFirstCard, indexOfLastCard);
//   const totalPages = Math.ceil(sortedCards.length / cardsPerPage);

//   const displayCards = searchResults !== null ? searchResults : currentCards;

//   const [selectedPackage, setSelectedPackage] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const handleViewDetails = (card) => {
//     // const cardWithToggle = {
//     //   ...card,
//     //   TestsAndComp: card.TestsAndComp.map((test) =>
//     //     typeof test === "string"
//     //       ? {
//     //           name: test,
//     //           department: "SEROLOGY",
//     //           reportTime: 0,
//     //           preparation: "No special preparation",
//     //           serviceKey: `Service Key for ${test}`,
//     //           showDetails: false,
//     //         }
//     //       : test
//     //   ),
//     //   toggleTest: (index) => {
//     //     const updated = [...card.TestsAndComp];
//     //     updated[index].showDetails = !updated[index].showDetails;
//     //     setSelectedPackage({ ...cardWithToggle, TestsAndComp: updated });
//     //   },
//     // };
//     setSelectedPackage(card);
//     setIsModalOpen(true);
//   };

//   const [compareList, setCompareList] = useState([]);
//   const [isCompareModalOpen, setIsCompareModalOpen] = useState(false);
//   const [showCompareModal, setShowCompareModal] = useState(false);
//   const [showCompareBox, setShowCompareBox] = useState(false);

//   const handleToggleCompare = (selectedCard) => {
//     const alreadyInList = compareList.some(
//       (c) => c.service_name === selectedCard.service_name
//     );
//     let newList;
//     if (alreadyInList) {
//       newList = compareList.filter(
//         (c) => c.service_name !== selectedCard.service_name
//       );
//     } else {
//       newList = [...compareList, selectedCard];
//     }
//     setCompareList(newList);
//     setShowCompareBox(newList.length > 0);
//   };

//   const handleCompare = (e) => {
//     e.preventDefault();

//     if (compareList.length < 2 || compareList.length > 3) {
//       alert(`Select a minimum of 2 and a maximum of 3 packages to compare.`);
//       return;
//     }
//     setShowCompareModal(true);
//     setIsCompareModalOpen(false);
//   };

//   const handleCloseCompareBox = () => {
//     setShowCompareBox(false);
//     setCompareList([]);
//   };

//   const handleBookNowFromCompare = (packageData) => {
//     handleAddToCart(packageData);
//     navigator("/home-collection");
//   };

//   const [renderMode, setRenderMode] = useState("buttons");

//   // if (loading) {
//   //   return <CustomLoader />;
//   // }

//   const goTestFunction = () => {
//     navigate('/test-packages')
//   }







//   // POPUP STATES
//   const [showFilterPopup, setShowFilterPopup] = useState(false);

//   // Temporary values used inside popup
//   const [tempFilters, setTempFilters] = useState({
//     fasting: filters.fasting || "All",
//     gender: filters.gender || "All",
//     ageRange: filters.ageRange || "All",
//   });

//   const [tempSort, setTempSort] = useState(sortOrder || "none");



//   return (
//     <>
//       <div className="ourPackageContainer ourPackagePageContainer">
//         {/* <div className="ourPackageUpperSection">
//           <AnimatedText tag="h2" type="words" y={30} className="rb-title">
//             Our Packages
//           </AnimatedText>

//           <p className="paraText">
//             RB Diagnostic offers a comprehensive range of health check-up
//             packages tailored for every stage of life.
//           </p>
//           <p className="paraText">
//             Each package is designed by experts to provide accurate insights and
//             support preventive healthcare, ensuring timely diagnosis and better
//             health outcomes.
//           </p>

//           <AnimatedText tag="p" type="words" y={-20} className="paraText">
//                         RB Diagnostic offers a comprehensive range of health check-up packages tailored for every stage of life.
//                     </AnimatedText>
//                     <AnimatedText tag="p" type="words" y={-20} className="paraText">
//                         Each package is designed by experts to provide accurate insights and support preventive healthcare, ensuring timely diagnosis and better health outcomes.
//                     </AnimatedText>
//         </div> */}

//         {/* <div className="midNavButtons">
//           {renderMode === "dropdown" ? (
//             <select
//               className="mobileDropdown"
//               value={activeTab}
//               onChange={(e) => {
//                 setActiveTab(e.target.value);
//                 setCurrentPage(1);
//               }}
//             >
//               {categories.map((category) => (
//                 <option key={category} value={category}>
//                   {category}
//                 </option>
//               ))}
//             </select>
//           ) : (
//             <div
//               className={`buttonContainer ${
//                 renderMode === "singleColumn" ? "columnView" : ""
//               }`}
//             >
//               {categories.map((category) => (
//                 <button
//                   key={category}
//                   className={`navBtn ${activeTab === category ? "active" : ""}`}
//                   onClick={() => {
//                     setActiveTab(category);
//                     setCurrentPage(1);
//                   }}
//                 >
//                   {category}
//                 </button>
//               ))}
//             </div>
//           )}
//         </div> */}
//         <div className="searchBarWrapper">
//           <GiHypodermicTest
//             className="inputIcon"
//             style={{ marginLeft: "1rem" }}
//           />
//           <input
//             type="text"
//             value={searchQuery}
//             onChange={(e) => handleSearch(e.target.value)}
//             placeholder="Search for Packages..."
//           />
//           {searchQuery && (
//             <CloseOutlinedIcon
//               fontSize="small"
//               style={{ color: "red" }}
//               onClick={handleClearSearch}
//             />
//           )}
//           <SearchOutlinedIcon fontSize="medium" style={{ color: "gray" }} />
//         </div>
//         {/* <div className="button-div">
//           <button onClick={goTestFunction} className="goTestButton">
//             Go To Test
//           </button>
//         </div> */}

//         {/* <div className="filterIconBtn" onClick={() => {
//           setTempFilters(filters);
//           setTempSort(sortOrder);
//           setShowFilterPopup(true);
//         }}>
//           <img src="/icons/filter.svg" alt="Filter" />
//         </div> */}

//         <div className="doctors-header-bar">
//           <div className="showingDiv">
//             <h3>
//               Showing <span>{12}</span> Doctors For You
//             </h3>
//           </div>

//           <div className="header-controls">
//             <div>
//               {/* Filter Icon */}
//               <div className="filters-Section">
//                 <label htmlFor="sort-select">Filter:</label>
//                 <button
//                   onClick={() => {
//                     setTempFilters(filters);
//                     setTempSort(sortOrder);
//                     setShowFilterPopup(true);
//                   }}
//                   className="filter-btn"
//                 >
//                   <FaFilter className="filter-icon" />
//                 </button>
//               </div>
//             </div>

//             <div className="filterSection">
//               <div className="filterHeader">
//                 <p style={{ margin: 0, fontSize: "16px" }}>Sort By</p>
//                 <div className="filterButtonsSec">
//                   <button
//                     className="rbdButton reset-Btn"
//                     onClick={handleRadioResetFilters}
//                   >
//                     <span className="btn-text">Reset</span>
//                   </button>
//                 </div>
//               </div>
//               <hr />

//               <label htmlFor="all" className="filter-class">
//                 <input
//                   type="radio"
//                   name="sortOrder"
//                   value="asc"
//                   checked={sortOrder === "asc"}
//                   onChange={() => setSortOrder("asc")}
//                 />
//                 Price: Ascending
//               </label>

//               <label htmlFor="all" className="filter-class">
//                 <input
//                   type="radio"
//                   name="sortOrder"
//                   value="desc"
//                   checked={sortOrder === "desc"}
//                   onChange={() => setSortOrder("desc")}
//                 />
//                 Price: Descending
//               </label>
//               <p style={{ margin: 0, fontSize: "16px" }}>Must Have Test</p>
//               <hr />
//               <TestDropdown
//                 testList={testList}
//                 selectedTests={selectedTests}
//                 onTestSelect={(serviceName) => {
//                   const newSelected = [...selectedTests, serviceName];
//                   setSelectedTests(newSelected);
//                   // Only show packages that contain ALL selected tests
//                   const filtered = packageList.filter((pkg) => {
//                     if (!Array.isArray(pkg?.list)) return false;
//                     // For each selected test, it must be present in pkg.list
//                     return newSelected.every((sel) =>
//                       pkg.list.some(
//                         (item) =>
//                           item.service_name &&
//                           sel.toLowerCase() === item.service_name.toLowerCase()
//                       )
//                     );
//                   });
//                   setSearchResults(filtered);
//                   setCurrentPage(1);
//                 }}
//                 onDeleteTest={(serviceName) => {
//                   const newSelected = selectedTests.filter(
//                     (t) => t !== serviceName
//                   );
//                   setSelectedTests(newSelected);
//                   if (newSelected.length === 0) {
//                     setSearchResults(null);
//                   } else {
//                     const filtered = packageList.filter((pkg) => {
//                       if (!Array.isArray(pkg?.list)) return false;
//                       return newSelected.every((sel) =>
//                         pkg.list.some(
//                           (item) =>
//                             item.service_name &&
//                             sel.toLowerCase() ===
//                             item.service_name.toLowerCase()
//                         )
//                       );
//                     });
//                     setSearchResults(filtered);
//                   }
//                   setCurrentPage(1);
//                 }}
//               />
//             </div>
//           </div>
//         </div>


//         <div className="packageBodySection">
//           <div className="packageBodyLeftSection">
//             {/* FILTERS */}

//             <div className="filterSection">
//               <div className="filterHeader">
//                 <p style={{ margin: 0, fontSize: "16px" }}>Filter By</p>

//                 <div className="filterButtonsSec">
//                   <button
//                     className="rbdButton reset-Btn"
//                     onClick={handleResetFilters}
//                   >
//                     <span className="btn-text">Reset</span>
//                   </button>
//                 </div>
//               </div>

//               <hr />
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   gap: "0.5rem",
//                   marginBottom: "1rem",
//                 }}
//               >
//                 <select
//                   value={filters.fasting}
//                   onChange={(e) => {
//                     setFilters({ ...filters, fasting: e.target.value });
//                     setCurrentPage(1);
//                   }}
//                 >
//                   <option value="All">Fasting (All)</option>
//                   <option value="Y">Yes</option>
//                   <option value="N">No</option>
//                 </select>
//                 <select
//                   value={filters.gender}
//                   onChange={(e) => {
//                     setFilters({ ...filters, gender: e.target.value });
//                     setCurrentPage(1);
//                   }}
//                 >
//                   <option value="All">Gender (All)</option>
//                   <option value="M">Male</option>
//                   <option value="F">Female</option>
//                   <option value="A">Any</option>
//                 </select>
//                 <select
//                   value={filters.ageRange}
//                   onChange={(e) => {
//                     setFilters({ ...filters, ageRange: e.target.value });
//                     setCurrentPage(1);
//                   }}
//                 >
//                   <option value="All">Age Range (All)</option>
//                   <option value="0-17">0-17</option>
//                   <option value="18-35">18-35</option>
//                   <option value="36-50">36-50</option>
//                   <option value="51+">51+</option>
//                 </select>
//               </div>
//             </div>
//             <div className="filterSection">
//               <div className="filterHeader">
//                 <p style={{ margin: 0, fontSize: "16px" }}>Sort By</p>
//                 <div className="filterButtonsSec">
//                   <button
//                     className="rbdButton reset-Btn"
//                     onClick={handleRadioResetFilters}
//                   >
//                     <span className="btn-text">Reset</span>
//                   </button>
//                 </div>
//               </div>
//               <hr />

//               <label htmlFor="all" className="filter-class">
//                 <input
//                   type="radio"
//                   name="sortOrder"
//                   value="asc"
//                   checked={sortOrder === "asc"}
//                   onChange={() => setSortOrder("asc")}
//                 />
//                 Price: Ascending
//               </label>

//               <label htmlFor="all" className="filter-class">
//                 <input
//                   type="radio"
//                   name="sortOrder"
//                   value="desc"
//                   checked={sortOrder === "desc"}
//                   onChange={() => setSortOrder("desc")}
//                 />
//                 Price: Descending
//               </label>
//               <p style={{ margin: 0, fontSize: "16px" }}>Must Have Test</p>
//               <hr />
//               <TestDropdown
//                 testList={testList}
//                 selectedTests={selectedTests}
//                 onTestSelect={(serviceName) => {
//                   const newSelected = [...selectedTests, serviceName];
//                   setSelectedTests(newSelected);
//                   // Only show packages that contain ALL selected tests
//                   const filtered = packageList.filter((pkg) => {
//                     if (!Array.isArray(pkg?.list)) return false;
//                     // For each selected test, it must be present in pkg.list
//                     return newSelected.every((sel) =>
//                       pkg.list.some(
//                         (item) =>
//                           item.service_name &&
//                           sel.toLowerCase() === item.service_name.toLowerCase()
//                       )
//                     );
//                   });
//                   setSearchResults(filtered);
//                   setCurrentPage(1);
//                 }}
//                 onDeleteTest={(serviceName) => {
//                   const newSelected = selectedTests.filter(
//                     (t) => t !== serviceName
//                   );
//                   setSelectedTests(newSelected);
//                   if (newSelected.length === 0) {
//                     setSearchResults(null);
//                   } else {
//                     const filtered = packageList.filter((pkg) => {
//                       if (!Array.isArray(pkg?.list)) return false;
//                       return newSelected.every((sel) =>
//                         pkg.list.some(
//                           (item) =>
//                             item.service_name &&
//                             sel.toLowerCase() ===
//                             item.service_name.toLowerCase()
//                         )
//                       );
//                     });
//                     setSearchResults(filtered);
//                   }
//                   setCurrentPage(1);
//                 }}
//               />
//             </div>
//             <div className="mainLeftDoctorImage">
//               <img src={png1} alt="Doctor png" />
//             </div>
//           </div>

//           {/* CARDS */}
//           {loading ? (
//             <CustomLoader />
//           ) : (
//             <div className="mainPackageCardSection">
//               {isMobile
//                 ? displayCards.map((card, index) => renderCard(card, index))
//                 : displayCards.map((card, index) => renderCard(card, index))}

//               <ViewPackageDetails
//                 isOpen={isModalOpen}
//                 onClose={() => setIsModalOpen(false)}
//                 packageData={selectedPackage}
//               />
//             </div>
//           )}
//         </div>


//         <CustomPagination
//           currentPage={currentPage}
//           totalPages={totalPages}
//           onChange={handlePageChange}
//         />
//       </div>

//       {showCompareBox && (
//         <FloatingCompareBox
//           compareList={compareList}
//           onCompareClick={handleCompare}
//           // onClose={() => setShowCompareBox(false)}
//           onClose={handleCloseCompareBox}
//         />
//       )}

//       {showCompareModal && (
//         <CompareModal
//           compareList={compareList}
//           onClose={() => setShowCompareModal(false)}
//           onBookNow={handleBookNowFromCompare}
//         />
//       )}


//       {showFilterPopup && (
//         <div className="popupOverlay">
//           <div className="filterPopup">

//             {/* HEADER */}
//             <div className="popupHeader">
//               <p>Filter & Sort</p>
//               <button className="closeBtn" onClick={() => setShowFilterPopup(false)}>✕</button>
//             </div>

//             <hr />

//             {/* FILTER SECTION */}
//             <div className="sectionTitle">Filter By</div>

//             <select
//               value={tempFilters.fasting}
//               onChange={(e) =>
//                 setTempFilters({ ...tempFilters, fasting: e.target.value })
//               }
//             >
//               <option value="All">Fasting (All)</option>
//               <option value="Y">Yes</option>
//               <option value="N">No</option>
//             </select>

//             <select
//               value={tempFilters.gender}
//               onChange={(e) =>
//                 setTempFilters({ ...tempFilters, gender: e.target.value })
//               }
//             >
//               <option value="All">Gender (All)</option>
//               <option value="M">Male</option>
//               <option value="F">Female</option>
//               <option value="A">Any</option>
//             </select>

//             <select
//               value={tempFilters.ageRange}
//               onChange={(e) =>
//                 setTempFilters({ ...tempFilters, ageRange: e.target.value })
//               }
//             >
//               <option value="All">Age Range (All)</option>
//               <option value="0-17">0-17</option>
//               <option value="18-35">18-35</option>
//               <option value="36-50">36-50</option>
//               <option value="51+">51+</option>
//             </select>

//             <hr />

//             {/* SORT SECTION */}
//             <div className="sectionTitle">Sort By</div>

//             <label className="radioRow">
//               <input
//                 type="radio"
//                 name="sort"
//                 value="none"
//                 checked={tempSort === "none"}
//                 onChange={() => setTempSort("none")}
//               />
//               None
//             </label>

//             <label className="radioRow">
//               <input
//                 type="radio"
//                 name="sort"
//                 value="asc"
//                 checked={tempSort === "asc"}
//                 onChange={() => setTempSort("asc")}
//               />
//               Price: Low to High
//             </label>

//             <label className="radioRow">
//               <input
//                 type="radio"
//                 name="sort"
//                 value="desc"
//                 checked={tempSort === "desc"}
//                 onChange={() => setTempSort("desc")}
//               />
//               Price: High to Low
//             </label>

//             {/* FOOTER BUTTONS */}
//             <div className="popupFooter">
//               <button
//                 className="resetBtn"
//                 onClick={() => {
//                   setTempFilters({
//                     fasting: "All",
//                     gender: "All",
//                     ageRange: "All",
//                   });
//                   setTempSort("none");
//                 }}
//               >
//                 Reset
//               </button>

//               <button
//                 className="applyBtn"
//                 onClick={() => {
//                   setFilters(tempFilters);
//                   setSortOrder(tempSort);
//                   setShowFilterPopup(false);
//                   setCurrentPage(1);
//                 }}
//               >
//                 Apply
//               </button>
//             </div>

//           </div>
//         </div>
//       )}

//     </>
//   );
// };

// export { OurPackageMainSection, getDiscountedPrice };




import { FaShoppingCart } from "react-icons/fa";
import cornerIcon from "../../Assets/cornerIcon.png";
import { useState, useEffect } from "react";
import "./OurPackagesPageCss/OurPackageMainSection.css";
import { IoSearchOutline } from "react-icons/io5";
import AnimatedText from "../../AnimatedText";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import PackageDetailsModal from "./PackageDetailsModel";

import png1 from "../../Assets/Medical doctor_ 1.png";

import CompareModal from "./CompareModal";
import FloatingCompareBox from "./FloatingCompareBox";

import rbdLogo from "../../Assets/rbdLogo.png";

import { useCart } from "../../Contexts/Cart.contexts";
import { getPackageList, getTestList } from "../../api/api";
import CustomPagination from "../../common/CustomPagination";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { GiHypodermicTest } from "react-icons/gi";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { getAgeRangeString, isAgeInRange } from "../../utils/helper";
import ViewPackageDetails from "./ViewPackageDetails";
import TestDropdown from "./TestDropdown";
import { TruncateText } from "../../common/TruncateText";
import CustomLoader from "../../common/loader/CustomLoader";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { FaFilter } from "react-icons/fa6";
import { useParams } from "react-router-dom";
import AgeRangeSlider from "./AgeRangeSlider";


const getDiscountedPrice = (originalPrice, offerPercent) => {
  if (!originalPrice || originalPrice <= 0) return 0;
  if (!offerPercent || offerPercent <= 0) return originalPrice;
  const discount = (offerPercent / 100) * originalPrice;
  return Math.round(originalPrice - discount);
};

const OurPackageMainSection = () => {

  const [copiedId, setCopiedId] = useState(null);
  


  const renderCard = (card, index) => {

    const isAdded = cartItems && cartItems.some((item) => item.id === card.service_id);

    const handleToggleCart = () => {
      if (isAdded) {
        // remove from cart
        setCartItems((prev) =>
          prev.filter((item) => item.id !== card.service_id)
        );
      } else {
        // add to cart
        // setCartItems((prev) => [...prev, { id: card.service_id, ...card }]);
        handleAddToCart(card);
      }
    };

    // const packageLink = `${window.location.origin}/RBD/service/OurPackagesPage${card.service_id}`;

    
    // const packageLink = `${window.location.origin}/rbweb-react/service/OurPackagesPage${card.service_id}`;
    const packageLink = `${window.location.origin}/service/OurPackagesPage${card.service_id}`;

    // const handleCopyLink = () => {
    //   navigator.clipboard.writeText(packageLink);
    //   setCopied(true);
    // };

    const handleCopyLink = () => {
      navigator.clipboard.writeText(packageLink);
      setCopiedId(card.service_id);
      setTimeout(() => setCopiedId(null), 3000);
    };


    return (
      <div key={index} className="carouselCardWrapper">
        <div className="packageCard mainPackageCard wide-card">
          <div className="cornerImage">
            <div className="upperCardText">
              <img className="logoimg" src={rbdLogo} alt="RBD logo" />
            </div>
            <img
              src={cornerIcon}
              alt="corner icon"
              style={{ width: "3.5rem" }}
            />
          </div>

          <div className="cardTitlePack mainpackageTitlePack">
            <h2
              style={{ margin: "5px 0px", fontSize: "18px", color: "#0fb7a4" }}
            // title={card?.service_name}
            >
              {/* {card?.service_name.length > 25
              ? `${card?.service_name.slice(0, 25)}...`
              : card?.service_name} */}
              <TruncateText text={card?.service_name} maxLength={35} />
            </h2>
          </div>

          <span className="testAndComp" style={{ color: "darkcyan" }}>
            <p>
              Covers {card?.list.length} Tests with {card?.NoOfParams}{" "}
              components{" "}
            </p>

            {card.parameters && card.parameters.length > 0 && (
              <div className="cardParameters">
                <h4
                  style={{
                    fontSize: "15px",
                    fontWeight: "700",
                    marginTop: "10px",
                    margin: "0",
                  }}
                >
                  Parameters
                </h4>
                <ul style={{ paddingLeft: "20px", margin: "5px 0" }}>
                  {card?.list.map((param, idx) => (
                    <li
                      key={idx}
                      style={{ textDecoration: "none", fontSize: "13px" }}
                    >
                      {param}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </span>

          <div className="priceSection">
            <h2 style={{ fontSize: "14px", color: "red" }}>
              &#8377; <del>{card.PackageRate}</del>
            </h2>
            <h2 style={{ fontSize: "14px", color: "green" }}>
              {card?.priceOff}% Off
            </h2>
            <h2 style={{ margin: "0", color: "grey", fontSize: "14px" }}>
              &#8377; {Number(card.price)}/-
            </h2>
          </div>

          <div className="compareSectionOurPackage">
            <div className="cardLowerRigntSec">
              <input
                type="checkbox"
                id={`compare-${index}`}
                checked={compareList.some(
                  (c) => c.service_name === card.service_name
                )}
                onChange={() => handleToggleCompare(card)}
              />
              <label htmlFor={`compare-${index}`}>Compare</label>
            </div>
            <div className="cardLowerRightRight">
              <p
                onClick={handleCopyLink}
                style={{
                  color: "#0fb7a4",
                  cursor: "pointer",
                  fontSize: "13px",
                  marginTop: "5px",
                  textAlign: "center"
                }}
              >
                🔗 {copiedId === card.service_id ? "Copied" : "Copy Link"}

              </p>
            </div>


          </div>

          <div className="cardLowerSec">
            <button
              className="rbdButton"
              title="Click to View Details"
              onClick={() => handleViewDetails(card)}
            >
              <span className="btn-text">View Details</span>
            </button>
            <button
              className={`rbdButton addCartBtn ${isAdded ? "added" : ""}`}
              title={isAdded ? "Added" : "Item Added"}
              onClick={handleToggleCart}
            >
              <span className="btn-text">
                {isAdded ? "Remove" : "Add to Cart"}
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  };

  const SkeletonCard = () => {
    return (
      <div className="packageCard skeleton-card">
        <div className="skeleton skeleton-image"></div>

        {/* <div className="skeleton skeleton-title"></div>
        <div className="skeleton skeleton-subtitle"></div> */}

        <div className="skeleton skeleton-line"></div>
        <div className="skeleton skeleton-line short"></div>

        <div className="skeleton skeleton-price"></div>
        <div className="skeleton skeleton-button"></div>
      </div>
    );
  };



  const navigate = useNavigate();
  const { addToCart, cartItems, setCartItems } = useCart();

  const [packageList, setPackageList] = useState([]);
  const [testList, setTestList] = useState([]);

  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState(null);
  const [tempAgeRange, setTempAgeRange] = useState([0, 100]);

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const cardsPerPage = 15;

  // filtering
  const [filters, setFilters] = useState({
    fasting: "All",
    gender: "All",
    ageRange: "All",
  });

  // temporary filter for popup
  const [tempFilters, setTempFilters] = useState({
    fasting: "All",
    gender: "All",
    ageRange: "All",
  });

  // sort order
  const [sortOrder, setSortOrder] = useState("default");
  const [tempSortOrder, setTempSortOrder] = useState("default");

  // must-have tests
  const [selectedTests, setSelectedTests] = useState([]);

  // compare
  const [compareList, setCompareList] = useState([]);
  const [showCompareBox, setShowCompareBox] = useState(false);
  const [showCompareModal, setShowCompareModal] = useState(false);

  // view details modal
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // popup state
  const [showFilterPopup, setShowFilterPopup] = useState(false);

  const fetchPackageListData = async () => {
    try {
      const preLoadedData = localStorage.getItem("packageList");
      if (preLoadedData) {
        setPackageList(JSON.parse(preLoadedData));
        return;
      }
      const res = await getPackageList({ search_key: "" });
      const filterShowInWeb =
        res?.data?.data?.filter((item) => item.ShowInWeb === "Y") || [];
      setPackageList(filterShowInWeb);
      localStorage.setItem("packageList", JSON.stringify(filterShowInWeb)); // cache
    } catch (e) {
      console.error("Error fetching package:", e);
    }
  };

  const fetchTestListData = async () => {
    // setLoading(true);
    try {
      const cachedData = localStorage.getItem("testList");
      if (cachedData) {
        setTestList(JSON.parse(cachedData));
      } else {
        const payload = {
          RBAuthKey: "RBDWAh!Q1s74e",
          Center_ID: "",
          search_key: "",
        };
        const res = await getTestList(payload);
        setTestList(res?.data?.data || []);
        localStorage.setItem("testList", JSON.stringify(res?.data?.data || []));
      }
    } catch (e) {
      // setLoading(false);
      console.error("Error fetching test list:", e);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      // Clear cache when country changes to force fresh API call
      localStorage.removeItem("packageList");
      await Promise.all([fetchPackageListData(), fetchTestListData()]);
      setLoading(false);
    };

    loadData();
  }, [localStorage.getItem("country")]);




  // search
  const handleSearch = (query) => {
    setSearchQuery(query);
    const trimmed = query.trim().toLowerCase();
    if (!trimmed) {
      setSearchResults(null);
      return;
    }
    const filtered = packageList.filter((card) =>
      (card?.service_name || "").toLowerCase().includes(trimmed)
    );
    setSearchResults(filtered);
    setCurrentPage(1);
  };

  const handleClearSearch = () => {
    setSearchQuery("");
    setSearchResults(null);
  };

  // Age range helper
  const isAgeInRange = (minAge, maxAge, selectedRange) => {
  if (!selectedRange || selectedRange.length !== 2) return true;
  const [filterMin, filterMax] = selectedRange;

  // Overlapping check:
  if (maxAge < filterMin || minAge > filterMax) return false;
  return true;
};

  // Main filter logic
  const filterCards = (cards) => {
    return cards.filter((card) => {
      const fastingMatch =
        filters.fasting === "All" ||
        card?.Fasting === filters.fasting;

      const genderMatch =
        filters.gender === "All" ||
        card?.Gender === filters.gender;

      const ageMatch = isAgeInRange(
        card?.minAge,
        card?.maxAge,
        filters.ageRange
      );

      // must have tests
      const mustHaveMatch = selectedTests.every((sel) =>
        card?.list?.some(
          (item) =>
            item?.service_name &&
            sel.toLowerCase() === item.service_name.toLowerCase()
        )
      );

      return fastingMatch && genderMatch && ageMatch && mustHaveMatch;
    });
  };

  // Sorting
  const sortCards = (cards) => {
    if (sortOrder === "asc") {
      return [...cards].sort((a, b) => (a.price || 0) - (b.price || 0));
    }
    if (sortOrder === "desc") {
      return [...cards].sort((a, b) => (b.price || 0) - (a.price || 0));
    }
    return cards;
  };

  const filteredCards = filterCards(packageList);
  const sortedCards = sortCards(filteredCards);

  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  const currentCards = sortedCards.slice(indexOfFirstCard, indexOfLastCard);

  const displayCards =
    searchResults !== null ? searchResults : currentCards;

  const totalPages = Math.ceil(sortedCards.length / cardsPerPage);

  // Add to cart
  const handleAddToCart = (pkg) => {
    const exists = cartItems.some((item) => item.id === pkg.service_id);
    if (exists) {
      return;
    }
    addToCart({
      id: pkg.service_id,
      product: pkg.service_name,
      price: pkg.price,
      quantity: 1,
    });
  };

  // compare toggle
  const handleToggleCompare = (selectedCard) => {
    const exists = compareList.some(
      (c) => c.service_name === selectedCard.service_name
    );
    const updated = exists
      ? compareList.filter(
        (c) => c.service_name !== selectedCard.service_name
      )
      : [...compareList, selectedCard];

    setCompareList(updated);
    setShowCompareBox(updated.length > 0);
  };

  const handleCompare = () => {
    if (compareList.length < 2 || compareList.length > 3) {
      alert("Select minimum 2 and maximum 3 packages.");
      return;
    }
    setShowCompareModal(true);
  };

  const handleBookNowFromCompare = (pkg) => {
    handleAddToCart(pkg);
    navigate("/home-collection");
  };

  const handleViewDetails = (card) => {
    setSelectedPackage(card);
    setIsModalOpen(true);
  };

  const handleCloseCompareBox = () => {
    setShowCompareBox(false);
    setCompareList([]);
  };

  const applyPopupFilters = () => {

    setFilters({
    ...tempFilters,
    ageRange: tempAgeRange,
  });
    setSortOrder(tempSortOrder);
    setShowFilterPopup(false);
    setCurrentPage(1);
  };

  const resetPopupFilters = () => {
    setTempAgeRange([0, 100]);
    setTempFilters({
      fasting: "All",
      gender: "All",
      ageRange: "All",
    });
    setTempSortOrder("default");
    setSelectedTests([]);
  };


  const { id } = useParams();

  // useEffect(() => {
  //   if (id) {
  //     const pkg = allPackages.find((item) => item.id === id);
  //     if (pkg) {
  //       setSelectedPackage(pkg);
  //       setIsModalOpen(true);
  //     }
  //   }
  // }, [id]);




  const closeModal = () => {
    setIsModalOpen(false);
    navigate("/OurPackagesPage");
  };

  // if (loading) {
  //   return <><h1>Loading...</h1></>
  // }


  return (
    <>
      <div className="ourPackageContainer testPackageContainer">
        {/* -------------------- SEARCH BAR -------------------- */}
        <div className="searchBarWrapper">
          <GiHypodermicTest
            className="inputIcon"
            style={{ marginLeft: "1rem" }}
          />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="Search for Packages"
          />
          {searchQuery && (
            <CloseOutlinedIcon
              fontSize="small"
              style={{ color: "red" }}
              onClick={handleClearSearch}
            />
          )}
          <SearchOutlinedIcon fontSize="medium" style={{ color: "gray" }} />
        </div>

        {/* -------------------- HEADER BAR -------------------- */}
        <div className="gridMainRightSection gridMainRightSection-package">
          {/* <div className="doctors-header-bar"> */}
          {/* <div className="showingDiv showNumberHealth">
            <h3>
              Showing <span>{filteredCards.length}</span> Health Packages For You
            </h3>
          </div> */}
          <div className="header-controls">
            {/* FILTER BUTTON */}
            <div className="filters-Section">
              {/* <label>Filter:</label> */}
              <button
                onClick={() => setShowFilterPopup(true)}
                className="filter-btn"
              >
                Filter: <FaFilter className="filter-icon" />
              </button>
            </div>

            {/* SORT BY DROPDOWN */}
            <div className="sort-dropdown">
              <label htmlFor="sort-select">Sort By:</label>

              <select
                id="sort-select"
                value={sortOrder}
                onChange={(e) => setSortOrder(e.target.value)}
              >
                <option value="default">Default</option>
                <option value="asc">Price (Low → High)</option>
                <option value="desc">Price (High → Low)</option>
              </select>
            </div>
          </div>
          {/* </div> */}
         
          {/* <div className="sort-dropdown">
            <label htmlFor="sort-select">Must Have Test:</label>
            <div className="dropdowntest" style={{
              marginTop: "1rem"

            }}>
              <TestDropdown
                testList={testList}
                selectedTests={selectedTests}
                onTestSelect={(test) => {
                  const updated = [...selectedTests, test];
                  setSelectedTests(updated);
                }}
                onDeleteTest={(test) => {
                  const updated = selectedTests.filter((t) => t !== test);
                  setSelectedTests(updated);
                }}
              />
            </div>


          </div> */}
          {/* <div style={{ display: 'flex',justifyContent:"center", alignItems:"center",gap:"1rem" }}>
            <span>Must Have Test:</span>

            <TestDropdown
              testList={testList}
              selectedTests={selectedTests}
              onTestSelect={(test) => {
                const updated = [...selectedTests, test];
                setSelectedTests(updated);
              }}
              onDeleteTest={(test) => {
                const updated = selectedTests.filter((t) => t !== test);
                setSelectedTests(updated);
              }}
            />
          </div> */}
          <div className="hp-button">
            <button className="rbdButton" onClick={() => navigate('/service/pathology')}>
              <span className="btn-text"> Go To Tests</span>
            </button>
          </div>

        </div>



        {/* -------------------- FILTER POPUP -------------------- */}
        {showFilterPopup && (
          <div className="filter-overlay">
            <div className="filter-modal">
              {/* POPUP HEADER */}

              <div className="popup-header">
                <h3>Filter Packages</h3>

                <button
                  className="close-btn-filter"
                  onClick={() => setShowFilterPopup(false)}
                >
                  ✖
                </button>
              </div>

              <hr />
              <div className="filter-section">
                {/* FASTING */}
                <div className="filter-group">
                  <label>Fasting Required</label>
                  <select
                    value={tempFilters.fasting}
                    onChange={(e) =>
                      setTempFilters({ ...tempFilters, fasting: e.target.value })
                    }
                  >
                    <option value="All">All</option>
                    <option value="Y">Yes</option>
                    <option value="N">No</option>
                  </select>
                </div>

                {/* GENDER */}
                <div className="filter-group">
                  <label>Gender</label>
                  <select
                    value={tempFilters.gender}
                    onChange={(e) =>
                      setTempFilters({ ...tempFilters, gender: e.target.value })
                    }
                  >
                    <option value="All">All</option>
                    <option value="M">Male</option>
                    <option value="F">Female</option>
                    <option value="A">Any</option>
                  </select>
                </div>

                {/* AGE RANGE */}
                <div className="filter-group">
                  <label>Age Range</label>
                  {/* <select
                    value={tempFilters.ageRange}
                    onChange={(e) =>
                      setTempFilters({ ...tempFilters, ageRange: e.target.value })
                    }
                  >
                    <option value="All">All</option>
                    <option value="0-17">0-17</option>
                    <option value="18-35">18-35</option>
                    <option value="36-50">36-50</option>
                    <option value="51+">51+</option>
                  </select> */}
                  <AgeRangeSlider ageRange={tempAgeRange} setAgeRange={setTempAgeRange}/>
                </div>

                {/* MUST-HAVE TEST DROPDOWN */}
                <div className="filter-group">
                  <label>Must Have Test</label>

                  <TestDropdown
                    testList={testList}
                    selectedTests={selectedTests}
                    onTestSelect={(test) => {
                      const updated = [...selectedTests, test];
                      setSelectedTests(updated);
                    }}
                    onDeleteTest={(test) => {
                      const updated = selectedTests.filter((t) => t !== test);
                      setSelectedTests(updated);
                    }}
                  />
                </div>
                {/* FOOTER BUTTONS */}
                <div className="filter-actions">
                  <button
                    onClick={resetPopupFilters}
                    className="rbdButton reset-Btn"
                  >
                    <span className="btn-text">Reset</span>
                  </button>

                  <button
                    onClick={applyPopupFilters}
                    className="rbdButton"
                  >
                    <span className="btn-text">Apply</span>
                  </button>

                </div>
              </div>
            </div>
          </div>
        )}

        {/* -------------------- LOADER -------------------- */}
        {/* {loading && <CustomLoader />} */}



        {/* -------------------- PACKAGE CARDS GRID -------------------- */}
        <div className="packageBodySection">
          {/* CARDS */}
          {loading ? (

            <div className="mainPackageCardSection">
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
                <SkeletonCard key={i} />
              ))}
            </div>

          ) : (
            <div className="mainPackageCardSection">
              {isMobile
                ? displayCards.map((card, index) => renderCard(card, index))
                : displayCards.map((card, index) => renderCard(card, index))}

              <ViewPackageDetails
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                packageData={selectedPackage}
              />
            </div>
          )}
        </div>

        {/* -------------------- PAGINATION -------------------- */}
        <div className="customPaginationSection">
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onChange={(page) => setCurrentPage(page)}
          />
        </div>

      </div>





      {/* -------------------- COMPARE FLOATING BOX -------------------- */}
      {showCompareBox && (
        <FloatingCompareBox
          compareList={compareList}
          onCompareClick={handleCompare}
          // onClose={() => setShowCompareBox(false)}
          onClose={handleCloseCompareBox}
        />
      )}


      {/* -------------------- COMPARE MODAL -------------------- */}
      {showCompareModal && (
        <CompareModal
          compareList={compareList}
          onClose={() => setShowCompareModal(false)}
          onBookNow={handleBookNowFromCompare}
        />
      )}


      {/* -------------------- VIEW DETAILS MODAL -------------------- */}
      {isModalOpen && (
        <ViewPackageDetails
          selectedPackage={selectedPackage}
          onClose={() => setIsModalOpen(false)}
          onBookNow={() => handleAddToCart(selectedPackage)}
        />
      )}
    </>
  );
};

export { OurPackageMainSection, getDiscountedPrice };
